// extracted by mini-css-extract-plugin
export var carousel = "styles-module--carousel--6a343";
export var container = "styles-module--container--ab2d1";
export var description = "styles-module--description--7a194";
export var header = "styles-module--header--6eafa";
export var section = "styles-module--section--870e9";
export var visible = "styles-module--visible--bd294";